import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { services } from "@/data/site";
import { Focus } from "@/components/home/Focus";
import { FadeUp, Stagger } from "@/components/motion/Reveal";
import { CtaBand } from "@/components/home/CtaBand";

export default function Leistungen() {
  const more = services.filter((s) => s.group !== "focus");
  return (
    <>
      <Seo title="Leistungen – Service, Reparaturen, Diagnose" description="Leistungen der NIVO Garage in Siebnen (SZ): Service & Wartung, Reparaturen, Diagnose & Elektronik sowie Bremsen, Reifen, Klimaservice und MFK – für Fahrzeuge aller Marken." />
      <PageHeader eyebrow="Leistungen" lines={["Was wir für", "Ihr Auto tun."]} text="Drei Schwerpunkte, ein Anspruch: Wir erklären, was Ihr Auto braucht, und besprechen die Kosten, bevor wir beginnen." />
      <Focus detailed />
      <section className="section border-t hairline">
        <div className="container-x">
          <FadeUp className="mb-8">
            <p className="eyebrow mb-4">Weitere Leistungen</p>
            <h2 className="h-section">Ausserdem kümmern wir uns um</h2>
          </FadeUp>
          <Stagger gap={0.04}>
            <ul className="border-t hairline">
              {more.map((s) => (
                <li key={s.slug} className="border-b hairline">
                  <Link to={`/leistungen/${s.slug}`} data-testid={`service-row-${s.slug}`} className="group grid grid-cols-[1fr_auto] md:grid-cols-[260px_1fr_auto] items-center gap-4 md:gap-8 py-5">
                    <span className="text-[19px] font-medium tracking-[-0.01em]">{s.title}</span>
                    <span className="hidden md:block text-[color:var(--ink-2)]">{s.short}</span>
                    <ArrowRight className="h-5 w-5 text-[color:var(--ink-3)] group-hover:text-[color:var(--violet)] group-hover:translate-x-1 transition-[color,transform] duration-300" />
                  </Link>
                </li>
              ))}
            </ul>
          </Stagger>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
